import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../../globals";
import { ProductsServices } from "../../../../services";

/**
 * Generated class for the ProductPartialWfoodcostAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-partial-wfoodcost-allergens',
    templateUrl: 'product-partial-wfoodcost-allergens.html',
})
export class ProductPartialWfoodcostAllergensPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public productsServices: ProductsServices) {
    }

    checkState(allergen_uid) {
        var index = this.productsServices.products_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            return true
        } else {
            return false
        }

    }

    insert(allergen_uid) {
        this.productsServices.products_allergens_tmp.push(allergen_uid);
    }

    delete(allergen_uid) {
        var index = this.productsServices.products_allergens_tmp.indexOf(allergen_uid, 0);
        if (index > -1) {
            this.productsServices.products_allergens_tmp.splice(index, 1);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-partial-wfoodcost-allergens/product-partial-wfoodcost-allergens.ts